import React from 'react';
import PropTypes from 'prop-types';
import ErrorPage from 'next/error';
import Twitter from '../../../endpoints/Twitter/Twitter';
import fetcher from '../../../utils/fetcher';
import query from '../../../endpoints/Twitter/twitter.gql';

const TwitterPage = ({ data, errorCode }) => {
  if (errorCode) return <ErrorPage statuscode={errorCode} />;
  return <Twitter data={data} />;
};

TwitterPage.getInitialProps = async ({
  query: { slug, previewToken },
  res,
}) => {
  let data;
  let errorCode;
  await fetcher(query, {
    contentAreaSlug: process.env.CONTENT_AREA_SLUG,
    slug: slug.join('/'),
    previewToken: previewToken,
  })
    .then((result) => {
      data = result;
      if (res) {
        res.setHeader('Cache-Control', 'public, max-age=60');
      }
      if (data && !data.twitter) {
        res.statusCode = 404;
        errorCode = res.statusCode > 200 ? res.statusCode : false;
      }
    })
    .catch(() => {
      res.statusCode = 404;
      errorCode = res.statusCode > 200 ? res.statusCode : false;
    });

  return {
    data,
    errorCode,
    layout: 'card',
  };
};

TwitterPage.propTypes = {
  data: PropTypes.object,
  errorCode: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
};

export default TwitterPage;
